var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketCurlyRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64V64C32 81.673 46.327 96 64 96H96C113.6 96 128 110.4 128 128V165.475C128 190.943 138.117 215.367 156.125 233.375L178.75 256L156.108 278.642C138.111 296.639 128 321.048 128 346.5V384C128 401.6 113.6 416 96 416H64C46.327 416 32 430.327 32 448V448C32 465.673 46.327 480 64 480H96C149.019 480 192 437.019 192 384V346.5C192 338.016 195.37 329.88 201.369 323.881L246.625 278.625C259.12 266.13 259.12 245.87 246.625 233.375L201.369 188.119C195.37 182.12 192 173.984 192 165.5V128C192 74.981 149.019 32 96 32H64C46.327 32 32 46.327 32 64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketCurlyRight);
export default __webpack_public_path__ + "static/media/bracket-curly-right.3e2bef2ddd95944129af95ce2feed7ce.svg";
export { ForwardRef as ReactComponent };